export const ANNUAL = 'annual';
export const QUARTERLY = 'quarterly';



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/annual-quarterly-selector/constants.js